// App.tsx
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, useHistory } from "react-router-dom";
import Frontpage from './Views/FrontpageView';
import AttendanceView from './Views/AttendanceView';
import ClassOverView from './Views/ClassOverView';
import CreateUserView from './Views/CreateUserView';
import LoginView from './Views/LoginView';
import myconfig from './Config';
import { useUserContext } from './Components/StateContext/UserContext'; // Ensure the path is correct
import UserSearchView from './Views/UserSearchView';
import CalenderView from './Views/CalenderView';
import MyUserDetailsView from './Views/MyUserDetailsView';
import UserDetailsView from './Views/UserDetailsView';
import PaymentView from './Views/PaymentView';
import LoginView2 from './Views/LoginView2';
import ExamRegistrationView from './Views/ExamRegistrationView';
import AthleticsRegistrationView from './Views/AthleticsRegistrationView';
import AthleticsEventsMatrixView from './Views/AthleticsEventsMatrixView';
import AthleticsScoresMatrixView from './Views/AthleticsScoresMatrixView';
import RegisterView from './Views/RegisterView';
import PersonvernView from './Views/PersonvernView';
import SalgsvilkaarView from './Views/SalgsvilkaarView';
import MedlemskontingentView from './Views/MedlemskontingentView';
import MedlemskontingentKvitteringView from './Views/MedlemskontingentKvitteringView';
import RapporterView from './Views/RapporterView';
import ExamRegistrationReportView from './Views/ExamRegistrationReportView';
import AthleticsRegistrationReportView from './Views/AthleticsRegistrationReportView';
import ConfigView from './Views/ConfigView';
import ExamConfigView from './Views/ExamConfigView';
import AthleticsConfigView from './Views/AthleticsConfigView';
import EpostKontoerView from './Views/EpostKontoerView';
import FellesEpostView from './Views/FellesEpostView';
import MasseutsendelserView from './Views/MasseutsendelserView';
import LatexEditorView from './Views/LatexEditorView';
import DokumenterView from './Views/DokumenterView';
import BilderView from './Views/BilderView';
import BilderConfigView from './Views/BilderConfigView';
import PaameldingView from './Views/PaameldingView';
import EditExamParticipantsView from './Views/EditExamParticipantsView';
import EditAthleticsParticipantsView from './Views/EditAthleticsParticipantsView';
import AuditLogView from './Views/AuditLogView';
import Footer from './Components/Footer';

const App = () => {
    const { user, userRoles, department, setToken, setDepartmentInfo, setUserInfo } = useUserContext();

    // Identify the session in OpenReplay once a user is logged in: email as the user id + metadata,
    // and their role(s). window.OpenReplay is the tracker stub (queues calls until it loads); it's
    // undefined on localhost, where the snippet skips tracking — so guard for it.
    useEffect(() => {
        const or = (window as any).OpenReplay;
        if (!or || !user?.Email) return;
        or.setUserID(user.Email);
        or.setMetadata('email', user.Email);
        if (userRoles && userRoles.length > 0) or.setMetadata('role', userRoles.join(', '));
    }, [user, userRoles]);

    const logoutCLicked = () => {
        setDepartmentInfo(null);
        setUserInfo(null);
        setToken(null);
        window.location.reload();
    };

    return (
        <>
            <div className="ods-grid__column--12">
                <div className="ods-color-bg-yellow ods-padding-3 ods-text--size-echo">
                    <div className="ods-grid ods-grid--gap ods-grid--dense">
                        <div className="ods-grid__column--12 ods-none-breakpoint-medium ods-text--align-center">
                            <a title={myconfig?.appVersion} href='/'>Annai Poopathi</a>
                        </div>
                        <div className="ods-grid__column--12 ods-grid__column--start-10-breakpoint-medium ods-grid__column--end-13-breakpoint-medium">
                            <div className="ods-text--align-right ods-text--size-kilo">{user?.Firstname} {user?.Lastname}
                                {user?.Id != null
                                    &&
                                    <a className='o-kom-link' onClick={logoutCLicked}> [Logg ut]</a>}
                            </div>
                        </div>
                        <div className="ods-grid__column--12 ods-grid__column--end-9-breakpoint-medium ods-text--size-kilo ods-text--size-echo-breakpoint-medium ods-none ods-block-breakpoint-medium">
                            <div className="ods-text--align-left">
                                <a title={myconfig?.appVersion} href='/'>Annai Poopathi</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Router>
                <Route exact path="/" component={Frontpage} />
                <Route exact path="/attendance/:classId/:week" component={AttendanceView} />
                <Route exact path="/payments" component={PaymentView} />
                <Route exact path="/payments/:depId" component={PaymentView} />
                <Route exact path="/classes/:depId" component={ClassOverView} />
                <Route exact path="/usersearch/:depId?" component={UserSearchView} />
                <Route exact path="/createuser/:depId" component={CreateUserView} />
                <Route exact path="/roombooking/:depId" component={CalenderView} />
                <Route exact path="/login" component={LoginView} />
                <Route exact path="/login2" component={LoginView2} />
                <Route exact path="/register" component={RegisterView} />
                <Route exact path="/privacy" component={PersonvernView} />
                <Route exact path="/salgsvilkar" component={SalgsvilkaarView} />
                <Route exact path="/medlemskontingent" component={MedlemskontingentView} />
                <Route exact path="/medlemskontingent/kvittering" component={MedlemskontingentKvitteringView} />
                <Route exact path="/reports" component={RapporterView} />
                <Route exact path="/reports/examregistration" component={ExamRegistrationReportView} />
                <Route exact path="/reports/athleticsregistration" component={AthleticsRegistrationReportView} />
                <Route exact path="/config" component={ConfigView} />
                <Route exact path="/config/exam" component={ExamConfigView} />
                <Route exact path="/config/athletics" component={AthleticsConfigView} />
                <Route exact path="/config/bilder" component={BilderConfigView} />
                <Route exact path="/bilder" component={BilderView} />
                <Route exact path="/dokumenter" component={DokumenterView} />
                <Route exact path="/latex" component={LatexEditorView} />
                <Route exact path="/latex/:id" component={LatexEditorView} />
                <Route exact path="/pamelding" component={PaameldingView} />
                <Route exact path="/pamelding/endre-eksamen" component={EditExamParticipantsView} />
                <Route exact path="/pamelding/endre-athletics" component={EditAthleticsParticipantsView} />
                <Route exact path="/auditlog" component={AuditLogView} />
                <Route exact path="/examregistration" component={ExamRegistrationView} />
                <Route exact path="/athleticsregistration" component={AthleticsRegistrationView} />
                <Route exact path="/athleticsregistration/matrix" component={AthleticsEventsMatrixView} />
                <Route exact path="/athleticsregistration/resultater" component={AthleticsScoresMatrixView} />
                <Route exact path="/userdetails/:userid/:usertype?" component={UserDetailsView} />
                <Route exact path="/myuserdetails" component={MyUserDetailsView} />
                <Route exact path="/fellesepost" component={EpostKontoerView} />
                <Route exact path="/fellesepost/masseutsendelser" component={MasseutsendelserView} />
                <Route exact path="/fellesepost/:account" component={FellesEpostView} />
            </Router>
            <Footer />
        </>
    );
};

export default App;
